module.exports = __webpack_public_path__ + "img/门禁道闸.aeb6e131.png";